import { Injectable, signal } from "@angular/core";
import { CurrencyPurchaseSelectionDto } from "../model/currency-purchase.selection.model";
import { CurrencyPurchaseApi } from "../service/currency-purchase.api";
import { CurrencyPurchaseDto } from "../model/currency-purchase.model";
import { CorpTranslateService } from "@corporate-tailwind/translation";

@Injectable({ providedIn: 'root' })
export class CurrencyPurchaseSelectionState {
    private readonly _selection = signal<CurrencyPurchaseSelectionDto | null>(null);
    private readonly _loading = signal<boolean>(true);
    private readonly _loadingCurrency = signal<boolean>(false);

    readonly selection = this._selection.asReadonly();
    readonly loading = this._loading.asReadonly();
    readonly loadingCurrency= this._loadingCurrency.asReadonly();

  constructor(    
    private _currencyPurchaseApi: CurrencyPurchaseApi,
    private _corpTranslateService: CorpTranslateService
) {
    this._corpTranslateService.attach(this._selection);
}

  load(currencyPurchaseDto: CurrencyPurchaseDto) {
    this._loading.set(true);

    this._currencyPurchaseApi.getDetailSelection(currencyPurchaseDto).subscribe({
      next: selection => {
        selection = this._corpTranslateService.translate(selection);


        this._selection.set(selection);
        this._loading.set(false);
      },
      error: err => {
        // console.error('Erreur api', err);
        this._loading.set(false);
      }
    });
  }

}